module.exports = __webpack_public_path__ + "img/_stopped.32af06dc.svg";